import axios from 'axios';

export const getMatchingAnnonces = async (customerId) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/matchings/${customerId}`;
    return axios.get(ApiUrl).then((response) => response.data);
};

export const acceptMatching = async (annonceId, matchingId) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/matchings/${matchingId}/accept`;
    return axios.post(ApiUrl).then((response) => response.data);
};

export const rejectMatching = async (annonceId, matchingId) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/matchings/${matchingId}/reject`;
    return axios.post(ApiUrl).then((response) => response.data);
};

export const hasMatchingAnnonces = async (annonceId) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/customers/annonces/${annonceId}/matchings`;
    return axios.get(ApiUrl)
        .then((response) => response.data.length > 0)
        .catch(() => false);
}; 